import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { FacilityService } from "../../../shared/services/facility.service";
import { VisitorStatusService } from "../report-services/visitor-status.service";
import { VisitorTypeService } from "../report-services/visitor-type.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";
import { UserService } from "../../../shared";

@Component({
	templateUrl: "./visitorsphotos3cols.component.html",
})
export class VisitorsPhotos3ColsComponent implements OnInit {
	constructor(
		private reportService: ReportService,
		//Insert Custom Services Here
		private visitortypeService: VisitorTypeService,
		private visitorstatusService: VisitorStatusService,
		private facilityService: FacilityService,
		private dialogService: DialogService,
		private userService: UserService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		FacilityID: 0,
		VisitorStatusID: 0,
		VisitorTypeID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
	};
	//Insert Custom Lists Here
	FacilityList: any = [];
	VisitorStatusList: any = [];
	VisitorTypeList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 381;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		//Insert Custom Init Methods Here
		this.loadFacilityList();
		this.loadVisitorStatusList();
		this.loadVisitorTypeList();
	}

	private loadFacilityList() {
		this.report.FacilityID = 0;
		var result = this.facilityService.loadFacilityRPTList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.FacilityList = response;

				this.FacilityList.unshift({
					FacilityID: 0,
					FacilityName: "All Facilities",
				});

				this.report.FacilityID = this.FacilityList[0].FacilityID;
			},
			(error) => {}
		);
	}

	private loadVisitorStatusList() {
		this.report.VisitorStatusID = 0;
		var result = this.visitorstatusService.loadVisitorStatusList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.VisitorStatusList = response;

				if (this.VisitorStatusList.length > 1) {
					// this.VisitorStatusList.unshift({
					//     VisitorStatusID: 0,
					//     VisitorStatusDesc: "All VisitorStatuss"
					// })
					this.report.VisitorStatusID = this.VisitorStatusList[0].VisitorStatusID;
				} else {
					this.report.VisitorStatusID = this.VisitorStatusList[0].VisitorStatusID;
				}
			},
			(error) => {}
		);
	}

	private loadVisitorTypeList() {
		this.report.VisitorTypeID = 0;
		var result = this.visitortypeService.loadVisitorTypeList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.VisitorTypeList = response;

				if (this.VisitorTypeList.length > 1) {
					// this.VisitorTypeList.unshift({
					//     VisitorTypeID: 0,
					//     VisitorTypeDesc: "All VisitorTypes"
					// })
					this.report.VisitorTypeID = this.VisitorTypeList[0].VisitorTypeID;
				} else {
					this.report.VisitorTypeID = this.VisitorTypeList[0].VisitorTypeID;
				}
			},
			(error) => {}
		);
	}
	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.FacilityID) {
		// 	this.errorMessage = "Select the Facility"
		// 	return;
		// }

		// if (!this.report.VisitorStatusID) {
		// 	this.errorMessage = "Select the VisitorStatus"
		// 	return;
		// }

		// if (!this.report.VisitorTypeID) {
		// 	this.errorMessage = "Select the VisitorType"
		// 	return;
		// }

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		// if (!this.report.UserID) {
		// 	this.errorMessage = "Select the User"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 381;

		var result = this.reportService.Print(reportID, strParam, 202, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: FacilityID
		strParam += this.report.FacilityID + "|FacilityID";

		//Parameter 2: VisitorStatusID
		strParam += "," + this.report.VisitorStatusID + "|VisitorStatusID";

		//Parameter 3: VisitorTypeID
		strParam += "," + this.report.VisitorTypeID + "|VisitorTypeID";

		//Parameter 4: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 5: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 6: UserID
		strParam += "," + this.user.userID + "|UserID";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
